module.exports = __webpack_public_path__ + "img/DELIVERY.412c436c.png";